import React            from 'react';
import ReactDom         from 'react-dom';
import Moment           from 'moment';

import Const            from 'fw_const';
import Utils            from 'utils';

import { Resizable } from 're-resizable';
// import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu'; // TODO: package not available
// -------------------------------------------------------

const DEFAULT_WIDTH = 130;

class Workflow extends React.Component {
  onResizable(item_no, e, data, ele) {
    Utils.request.bind(this)('/api/project/sheet/update_resize', { project_id: this.props.data.project.id, width: ele.clientWidth, item_no: item_no },
      function(res){
        this.props.updateSheet.bind(this)(res.body.sheet);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let sheet = this.props.sheet;
    
    const col2idx = c => c.split('').reduce((prev, c) => (prev * 26 + parseInt(c, 36) - 9), 0) - 1;
    const idx2col = n => ((n > 25 ? idx2col(Math.floor(n / 26 - 1)) : "") + (n % 26 + 10).toString(36).toUpperCase());
    
    return (
      <thead>
        <tr>
          <th className="cell read-only no" />
          
          { sheet.header.map((d, key) => {
            let width = (d.width == undefined || d.width == null) ? DEFAULT_WIDTH : d.width;
            
            let className = '';
            if( (key + 1) == this.props.select_row ) className += ' select-row'
            
            return (
              // TODO: ContextMenuTrigger not available (react-contextmenu missing) - rendered as plain th
              <th key={key} id={d.id}>
                <Resizable defaultSize={{ width: width }} className={className} minWidth={DEFAULT_WIDTH} onResizeStop={this.onResizable.bind(this, key)} enable={{ top:false, right:true, bottom:false, left:false, topRight:false, bottomRight:false, bottomLeft:false, topLeft:false }}>
                  <span>{idx2col(key)}</span>
                </Resizable>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Workflow;